import { z } from 'zod'

const group = z.object({
  account_id: z.number(),
  group_id: z.number(),
  ts_created: z.number(),
  name: z.string(),
  status: z.string(),
  auto_assign_enabled: z.boolean(),
  user_ids: z.array(z.number()),
})

export const groupsApiSchemas = {
  list: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.object({ groups: z.array(group) }),
  },
  create: {
    path: z.undefined(),
    query: z.undefined(),
    request: group.pick({
      name: true,
      user_ids: true,
    }),
    response: z.object({ group: group }),
  },
  delete: {
    path: z.undefined(),
    query: z.undefined(),
    request: group.pick({ group_id: true }),
    response: z.undefined(),
  },
  update: {
    path: z.undefined(),
    query: z.undefined(),
    request: group.pick({
      group_id: true,
      name: true,
    }),
    response: z.object({ group: group.omit({ user_ids: true }) }),
  },
  swithcAutoAssign: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.object({ group_id: z.number(), is_enabled: z.boolean() }),
    response: z.undefined(),
  },
  changeUsers: {
    path: z.undefined(),
    query: z.undefined(),
    request: group.pick({ group_id: true, user_ids: true }),
    response: group.pick({ user_ids: true }),
  },
}

export type Group = z.infer<typeof group>
